module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn-support-bf5277bbb584878f11a135d0718aa2c3.svg";